import { render, staticRenderFns } from "./ServiceSelectionView.vue?vue&type=template&id=5ef6473e&scoped=true"
import script from "./ServiceSelectionView.vue?vue&type=script&lang=js"
export * from "./ServiceSelectionView.vue?vue&type=script&lang=js"
import style0 from "./ServiceSelectionView.vue?vue&type=style&index=0&id=5ef6473e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef6473e",
  null
  
)

export default component.exports